exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3 {\n  color: #858585;\n  font-size: 20px;\n  font-weight: normal;\n  margin-bottom: 30px;\n}\nh3 span {\n  display: inline-block;\n  width: 30px;\n  line-height: 30px;\n  height: 30px;\n  border-radius: 2px;\n  color: #fff;\n  font-weight: bold;\n  font-size: 14px;\n  margin-right: 15px;\n  background: #d2001b;\n  text-align: center;\n}\nh3 span.green {\n  background: #669900;\n}\n\nh3 span.black {\n  background: #333333;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/title/title.component.css
// module id = ../../../../../src/app/shared/title/title.component.css
// module chunks = main